export const GETINGS_ALL_RIGHTS = "© Getinge 2025 | All Rights Reserved";
export const SIGN_OR_SIGNATURES = "Sign or get signatures";
export const VIEW = "View";
export const CARD_TEXT = [
    "Here's what's Happening with your documents today.",
];
export const SEND_DOCUMENTS_BTN = "Send Document";
export const GET_DOCUMENT_SIGNED = "Get Document Signed";
export const GET_DOCUMENT_SIGNED_TEXT = "Send a document to others for e-signing, approval, or other processing.Document signing takes place in the OneDoc DMS vault.";
export const DRAG_AND_DROP_FILE = "Drag & drop file or";
export const BROWSE = "Upload File";
export const SUPPORTED_FORMMATS = "(Max 10MB)";
export const AGREEMENT_NAME = "Agreement name";
export const MESSAGE = "Message";
export const DUE_DATE = "Due Date";
export const MAX_DAYS_FROM = "Max 30 days from today";
export const RECIPIENT_MUST_SIGN = "Recipient must sign in order";
export const RECIPIENT = "Recipient";
export const EMAIL = "Email"